import React from "react";
import {
  Home,
  ImageIcon,
  LayoutDashboard,
  Users,
  Building2,
  Package,
  ShoppingBag,
  FileText,
  Settings,
  Menu,
  ChevronRight,
} from "lucide-react"

export const NavConfig = {
  securePublicRoute: [
    {
      navItem: "Home",
      navPath: "/app/home",
      Icon: <Home className="h-6 w-6 ml-2" />,
    }
  ],
  secureTenantRoutes: [
    {
      index: 0,
      navItem: "Home",
      navPath: "home",
      navId: "home",
      Icon: <Home className="h-6 w-6" />,
    },
    {
      index: 1,
      navItem: "Dashboard",
      navPath: "dashboard",
      navId: "dashboard",
      Icon: <LayoutDashboard className="h-6 w-6" />,
    },
    {
      index: 2,
      navItem: "User Management",
      navPath: "user-management",
      navId: "usersmanagement",
      Icon: <Users className="h-6 w-6" />,
      permission: "UserManagement.View"
    },
    {
      index: 3,
      navItem: "Companies",
      navPath: "companies",
      navId: "companies",
      Icon: <Building2 className="h-6 w-6" />,
      permission: "RoleManagement.View"
    },
    {
      index: 4,
      navItem: "Product Category",
      navPath: "product-category",
      navId: "product-category",
      Icon: <Package className="h-6 w-6" />,
      permission: "ProductCategory.View"
    },
    {
      index: 5,
      navItem: "Product Types",
      navPath: "product-types",
      navId: "product-types",
      Icon: <Package className="h-6 w-6" />,
      permission: "ProductTypes.View"
    },
    {
      index: 6,
      navItem: "Product Design",
      navPath: "product-design",
      navId: "product-design",
      Icon: <Package className="h-6 w-6" />,
      permission: "ProductTypes.View"
    },
    {
      index: 7,
      navItem: "Products",
      navPath: "products",
      navId: "products",
      Icon: <ShoppingBag className="h-6 w-6" />,
      permission: "ProductManagement.View"
    },
    {
      index: 8,
      navItem: "Orders",
      navPath: "approvals",
      navId: "approvals",
      Icon: <FileText className="h-6 w-6" />,
      permission: "OrderManagement.View"
    }
  ],
};
